module.exports = __webpack_public_path__ + "static/img/img_14.d728a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/children_gallery/img_14.jpg
// module id = IMko
// module chunks = 0